<div class="h36"></div>
<div class="content contentBG fixTarget" id="content">
  <div class="rela">
    <div class="w1224 padT20B40">
      <div class="mianbaoDiv">
        <div class="floatL">您所在的位置：
          <a *ngIf="fromType == '0'" [routerLink]="['/gzEcommerceSearch']" [queryParams]="{userId: userId, userName: userName}">电商商务诚信</a>
          <a *ngIf="fromType == '1'" [routerLink]="['/gzLogisticsSearchComponent']" [queryParams]="{userId: userId, userName: userName}">物流商务诚信</a>
          》企业关联图谱</div>
        <div class="floatR taRight"><a onclick="history.go(-1);">返回上一页</a></div>
        <div style="clear: both"></div>
      </div>
      <div class="RsearchInputBox" style="margin: 0 auto;">
        <div style="position: relative; float: left;">
          <app-search-box #searchBox [useClass]="5"></app-search-box>
        </div>
        <button class="indSearchBtn" (click)="nTabs(0)">查询</button>
      </div>
      <div class="push"></div>
    </div>

    <div class="Tab1">
      <div class="Tab1Con">
        <div class="nTab">
          <div class="TabTitle w1224">
            <ul id="myTab">
              <li [class]="active === 0 ? 'active' : 'normal'" (click)="nTabs(0);" ><a>企业图谱</a></li>
              <li [class]="active === 1 ? 'active' : 'normal'" (click)="nTabs(1);" ><a>关联链图</a></li>
              <li [class]="active === 2 ? 'active' : 'normal'" (click)="nTabs(2);" ><a>股权结构</a></li>
              <!--<li [class]="active === 3 ? 'active' : 'normal'" (click)="nTabs(3);" ><a>实际控制人</a></li>-->
            </ul>
          </div>
          <div class="TabContent">
            <!--<router-outlet ></router-outlet>-->
            <app-enterp-map #childMap [hidden]="active !== 0" ></app-enterp-map>
            <app-enter-association-chain-graph #childChainGraph [hidden]="active !== 1" ></app-enter-association-chain-graph>
            <app-enter-stockright-structure #childStockRight [hidden]="active !== 2" ></app-enter-stockright-structure>
            <!--<app-enter-actual-control-person #childControlPerson [hidden]="active !== 3" ></app-enter-actual-control-person>-->
          </div>
        </div>
      </div>
    </div>

    <div class="push">
      <!--请浮动勿删-->
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enterp-atlas/enterp-atlas.component.html